import React, { Component } from 'react'
import { connect } from 'react-redux'
import CSSModules from 'helpers/CSSModulesUtil'
import { branch, compose, renderComponent } from 'recompose'
import T from 'i18n-react'
import Tag from 'components/display/Tag'
import { TAG_COLORS } from 'components/display/Tag/constants'
import LifecycleEdit from './LifecycleEdit'
import {
  projectWorkflowHistorySelector
} from './selectors'
import {
  workflowLifecycleSelector
} from 'containers/Project/View/selectors'
import styles from './styles.scss'
import { Flex } from 'reflexbox'
import DataChart from './DataChart'
import Divider from 'components/fulcrum/divider/Divider'

const mapStateToProps = (state) => ({
  history: projectWorkflowHistorySelector(state),
  lifecycle: workflowLifecycleSelector(state)
})

const mapDispatchToProps = (dispatch) => ({

})

class LifecycleBody extends Component {

  getLifecycleTag(){
    if(this.props.lifecycle){
      return (
        <Tag 
          large
          color={TAG_COLORS.GREEN} 
          text={this.props.lifecycle}
          className={styles.lifecycleTag}
        />
      )
    }
    return
  }

  render(){
    return (
      <div>
        <div styleName='lifecycleBodyContainer'>
          <Flex styleName='currentStateContainer'>
            <div styleName='currentStateLabel'>Currently in </div>
            {this.getLifecycleTag()}
          </Flex>
          <Divider styleName='lifecycleBodyDivider'/>
        </div>
        <h5 styleName='chartTitle'>History</h5>
        <DataChart history={this.props.history} />
      </div>
    );
  }
}

const withBranch = branch(({edit}) => edit, renderComponent(LifecycleEdit))
const withStyle = CSSModules(styles)
const withConnect = connect(mapStateToProps, mapDispatchToProps)

const enhance = compose(
    withBranch,
    withConnect,
    withStyle
)

export default enhance(LifecycleBody)